<div [formGroup]="checkoutForm">
    <div>
        <p>Amount</p>
        <input formControlName="amount">
        <p>email</p>
        <input formControlName="email">
        <p>customer name</p>
        <input formControlName="customerName">
        <p>message</p>
        <input formControlName="messageToCustomer">
    </div>
    <div>

    </div>
</div>
<div>
    <button (click)="postPaymentOrder()">Submit</button>
</div>
<div *ngIf="checkoutUrl">
    <a [href]="checkoutUrl">{{checkoutUrl}}</a>
</div>